// Common functions
export const setValueToStorage = (key, value) => localStorage.setItem(key, JSON.stringify(value));

export const getParsedValueFromStorage = key => {
    if(localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined') {
        return JSON.parse(localStorage.getItem(key)) 
    } else {
        return '';
    }
};
// export const getStringValueFromStorage = key => localStorage.getItem(key);

export const removeValueFromStorage = key => localStorage.removeItem(key);

export const clearStorage = () => localStorage.clear();

export const safeParse = (key, fallback) => {
    try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : fallback;
    } catch {
        return fallback;
    }
};

export const setDealCart = cartArr => localStorage.setItem("dealCart", JSON.stringify(cartArr));
export const getDealCart = () => JSON.parse(localStorage.getItem("dealCart"));